import React from "react";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
  UncontrolledTooltip,
  Input,
  FormGroup
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import PaginationComponent from "../../components/Custom/Pagination";
// import ConfirmationModal from "../components/ConfirmationModal/ConfirmationModal";
import { getRunsRequest, getRunsStatsRequest } from '../../api/run';
import { calcStartEndPage } from '../../helpers/pagination';
import { formatRunStatus } from "../../helpers/status";
import { getCityFromAddress } from "helpers/run";
import { runsStatus } from "constants/status";

class Runs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            runs: null,
            page: 0,
            total: 0,
            limit: 25,
            pages: 0,
            current_page: 0,
            start_page: 0,
            end_page: 9,
            first_page: 0,
            last_page: 0,
            stats: null,
            search: '',
            status: '',
        }
        this.timeout = null;
    }

    async componentDidMount() {
        await this.getRuns();
        await this.getStats();
    }

    getRuns = async () => {        
        const { limit, page, search, status } = this.state;
        const runsObj = await getRunsRequest(page, limit, search, status);
        const runs = runsObj.runs;
        const total = runsObj.total;
        const pages = Math.ceil(total / limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            runs,
            total,
            pages,
            last_page,
            end_page
        })
    }

    getStats = async () => {
        const stats = await getRunsStatsRequest();
        this.setState({
            stats
        })
    }
  
    goTo = path => this.props.history.push(path);

    goToPage = async (page) => {
        const { limit, pages, search } = this.state;
        const runsObj = await getRunsRequest(page, limit, search);
        const runs = runsObj.runs;
        const { start_page, end_page } = calcStartEndPage(page, pages);

        this.setState({
            runs: runs,
            current_page: page,
            start_page: start_page,
            end_page: end_page
        })
    }
    
    onChangeFilter = (event) => {

		const { name, value } = event.target;
		this.setState({
			[name]: value,
			page: 0
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getRuns();
		}, 300);
    }
    
    /*deleteRun = async () => {
		const { deleteRunId } = this.state;
        await deleteRunRequest(deleteRunId);
        this.getRuns();
	}*/

	/*openConfirmation = (runId) => () => {
		this.setState({
			deleteRunId: runId
		});
		this.deleteConfirmationModal.toggle();
	}*/

    onSelectChange = (value) => {
		this.onChangeFilter({ target: { value: value, name: 'company' } });
	}

    render() {

        const {
            runs,
            pages,
            current_page,
            start_page,
            end_page,
            stats,
            search,
            status,
            company
        } = this.state;

        const runCount = stats ? stats.runCount : 0;
        const openRunsCount = stats ? stats.openRunsCount : 0;

        return (
            <>
            <div className="content">
            <Row>
                <Col xs="12">
                    <Card className="card-chart">
                        <CardHeader>
                            <Row>
                                <Col lg="6" md="6">
                                    <Card className="card-stats">
                                        <CardBody>
                                        <Row>
                                            <Col xs="5">
                                            <div className="info-icon text-center icon-warning">
                                                <i className="tim-icons icon-bag-16" />
                                            </div>
                                            </Col>
                                            <Col xs="7">
                                            <div className="numbers">
                                                <p className="card-category">Runs</p>
                                                <CardTitle tag="h3">{runCount}</CardTitle>
                                            </div>
                                            </Col>
                                        </Row>
                                        </CardBody>
                                        <CardFooter>
                                        <hr />
                                        <div className="stats">
                                            <i className="tim-icons icon-refresh-01" /> Updated Now
                                        </div>
                                        </CardFooter>
                                    </Card>
                                </Col>
                                <Col lg="6" md="6">
                                    <Card className="card-stats">
                                        <CardBody>
                                        <Row>
                                            <Col xs="5">
                                            <div className="info-icon text-center icon-warning">
                                                <i className="tim-icons icon-check-2" />
                                            </div>
                                            </Col>
                                            <Col xs="7">
                                            <div className="numbers">
                                                <p className="card-category">Open Runs</p>
                                                <CardTitle tag="h3">{openRunsCount}</CardTitle>
                                            </div>
                                            </Col>
                                        </Row>
                                        </CardBody>
                                        <CardFooter>
                                        <hr />
                                        <div className="stats">
                                            <i className="tim-icons icon-refresh-01" /> Updated Now
                                        </div>
                                        </CardFooter>
                                    </Card>
                                </Col>
                            </Row>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4" className="d-inline-block">
                            Runs
                        </CardTitle>
                        <FormGroup>
                            <Input placeholder="Search Runs..." name="search" value={search} type="text" onChange={this.onChangeFilter}></Input>
                        </FormGroup>
                        <FormGroup>
                            <Input
                                type="select"
                                name="status"
                                value={status}
                                onChange={this.onChangeFilter}
                            >
                                <option value={''}>-- SELECT STATUS --</option>
                                {runsStatus.map(status => (
                                    <option value={status}>{formatRunStatus(status)}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </CardHeader>
                    <CardBody>
                    <Table responsive>
                        <thead className="text-primary">
                        <tr>
                            <th>Created</th>
                            <th>Driver</th>
                            <th>Order / Transfer</th>
                            <th>City</th>
                            <th>Status</th>
                            <th className="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {runs && runs.length
                        ? runs.map((run) => {
                            return (
                                <tr key={run._id}>
                                    <td>{moment(run.createdAt).format('MM/DD/YYYY HH:mm')}</td>
                                    <td>{run.driver 
                                        ? <Link to={`/user?id=${run.driver.user}`}>{run.driver.firstName} {run.driver.lastName}</Link>
                                        : "N/A"
                                    }</td>
                                    <td>{run.order 
                                        ? <Link to={`/order?id=${run.order._id}`}>{run.order._id}</Link>
                                        : run.transfer
                                            ? <Link to={`/transfer?id=${run.transfer._id}`}>{run.transfer._id}</Link>
                                            : "N/A"
                                    }</td>
                                    <td>{run.pickupAddress ? getCityFromAddress(run.pickupAddress) : "N/A"}</td>
                                    <td>{run.status ? formatRunStatus(run.status) : "N/A"}</td>
                                    <td className="text-right">
                                        <Button
                                            className="btn-link btn-icon"
                                            color="success"
                                            id={`tooltip-view-${run._id}`}
                                            size="sm"
                                            onClick={() => this.goTo(`/run?id=${run._id}`)}
                                        >
                                            <i className="tim-icons icon-zoom-split" />
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={0}
                                            target={`tooltip-view-${run._id}`}
                                        >
                                            View
                                        </UncontrolledTooltip>
                                    </td>
                                </tr>
                            )
                        })
                        :   <tr>
                                <td colSpan="6">There's no run in the database</td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                    {runs?.length > 0 && 
                        <PaginationComponent 
                            pages={pages}
                            current_page={current_page}
                            start_page={start_page}
                            end_page={end_page}
                            goToPage={this.goToPage}
                        />
                    }
                    </CardBody>
                </Card>
                </Col>
            </Row>
            {/*<ConfirmationModal
                ref={el => this.deleteConfirmationModal = el}
                title="Delete Run?"
                buttons={[
                    { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                    { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteRun }
                ]}
            >
                Are you sure you want to delete this run?
            </ConfirmationModal>*/}
            </div>
        </>
        );
    }
}

export default Runs;
